import videos from './features/responsive-videos'

/*
 * init modules
 */

const moduleElements = document.querySelectorAll('[data-feature]')

for (var i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i]
  const name = el.getAttribute('data-feature')

  try {
    const Module = require(`./features/${name}`).default
    new Module(el)
  } catch (error) {
    console.warn(error)
  }
}

/*
 * init FastClick
 */

import FastClick from 'fastclick'

FastClick.attach(document.body)



// WEBPACK FOOTER //
// ./src/javascript/index.js